// Top bar country and language menus (snippets/localization-preferences.liquid, part 'bar', style 'menus').
// Picking an option fills the Preferenze form and submits it with requestSubmit(), so the choice is remembered
// exactly like a choice saved in the Preferenze window.
if (!customElements.get("locale-menus")) {
  customElements.define(
    "locale-menus",
    class LocaleMenus extends HTMLElement {
      connectedCallback() {
        this.menus = [...this.querySelectorAll("[data-locale-menu]")];
        this.addEventListener("click", (event) => {
          const button = event.target.closest(".locale-menu__button");
          if (button) return this.toggle(button.closest("[data-locale-menu]"));
          const option = event.target.closest('[role="option"]');
          if (option) this.pick(option.closest("[data-locale-menu]"), option);
        });
        this.addEventListener("input", (event) => {
          if (event.target.matches(".locale-menu__search")) this.filter(event.target);
        });
        this.addEventListener("keydown", (event) => this.keys(event));
        this.onOutside = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        document.addEventListener("click", this.onOutside);
      }

      disconnectedCallback() {
        document.removeEventListener("click", this.onOutside);
      }

      panel(menu) {
        return menu.querySelector(".locale-menu__panel");
      }

      options(menu) {
        return [...menu.querySelectorAll('[role="option"]')].filter((option) => !option.hidden);
      }

      toggle(menu) {
        if (this.panel(menu).hidden) this.open(menu);
        else this.close(menu, true);
      }

      open(menu) {
        this.closeAll();
        const panel = this.panel(menu);
        panel.hidden = false;
        menu.querySelector(".locale-menu__button").setAttribute("aria-expanded", "true");
        const search = panel.querySelector(".locale-menu__search");
        const selected = menu.querySelector('[aria-selected="true"]');
        selected?.scrollIntoView({ block: "center" });
        (search || selected || this.options(menu)[0])?.focus();
        // Full country list not in the page HTML yet: load it (assets/header-lazy.js), then restore the view.
        const list = panel.querySelector(".locale-menu__list[data-lazy-url]");
        if (list && window.headerLazy) {
          panel.setAttribute("aria-busy", "true");
          window.headerLazy
            .fill(list)
            .catch(() => {})
            .finally(() => {
              panel.removeAttribute("aria-busy");
              if (panel.hidden) return;
              if (search) this.filter(search);
              menu.querySelector('[aria-selected="true"]')?.scrollIntoView({ block: "center" });
              if (!search && !list.contains(document.activeElement)) {
                (menu.querySelector('[aria-selected="true"]') || this.options(menu)[0])?.focus();
              }
            });
        }
      }

      close(menu, focusButton) {
        this.panel(menu).hidden = true;
        const button = menu.querySelector(".locale-menu__button");
        button.setAttribute("aria-expanded", "false");
        const search = menu.querySelector(".locale-menu__search");
        if (search && search.value) {
          search.value = "";
          this.filter(search);
        }
        if (focusButton) button.focus();
      }

      closeAll() {
        this.menus.forEach((menu) => {
          if (!this.panel(menu).hidden) this.close(menu);
        });
      }

      filter(search) {
        const term = search.value.trim().toLowerCase();
        search
          .closest("[data-locale-menu]")
          .querySelectorAll('[role="option"]')
          .forEach((option) => {
            option.hidden = term !== "" && !option.dataset.name.includes(term);
          });
      }

      pick(menu, option) {
        const form = document.getElementById("LocalizationPreferencesForm");
        const field = form?.querySelector(`input[name="${menu.dataset.localeMenu}"]`);
        if (!field || option.getAttribute("aria-selected") === "true") return this.close(menu, true);
        field.value = option.dataset.value;
        menu.querySelector(".locale-menu__button").setAttribute("aria-busy", "true");
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }

      keys(event) {
        const menu = event.target.closest("[data-locale-menu]");
        if (!menu) return;
        const panel = this.panel(menu);
        if (event.target.matches(".locale-menu__button") && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
          event.preventDefault();
          return this.open(menu);
        }
        if (panel.hidden) return;
        const options = this.options(menu);
        const index = options.indexOf(document.activeElement);
        if (event.key === "Escape") {
          event.preventDefault();
          this.close(menu, true);
        } else if (event.key === "ArrowDown") {
          event.preventDefault();
          options[Math.min(index + 1, options.length - 1)]?.focus();
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          (index <= 0 ? panel.querySelector(".locale-menu__search") || options[0] : options[index - 1])?.focus();
        } else if (event.key === "Enter" && event.target.matches(".locale-menu__search")) {
          event.preventDefault();
          if (options[0]) this.pick(menu, options[0]);
        } else if ((event.key === "Enter" || event.key === " ") && index >= 0) {
          event.preventDefault();
          this.pick(menu, options[index]);
        } else if (event.key === "Tab") {
          this.close(menu);
        }
      }
    },
  );
}
